import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {CanvasRendererComponent} from './Scene/canvas-renderer.component';
import {UpdateService} from '../Utils/update.service';


@Component({
    selector: 'surface-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    styles: []
})
export class ViewComponent implements AfterViewInit {
    @Input() reload: boolean;
    @ViewChild('renderer', {static: false}) renderer: CanvasRendererComponent;

    constructor(private updateService: UpdateService) {
    }

    ngAfterViewInit(): void {
        this.updateService.checkForUpdates();
    }

    public resize(init = false) {
        this.renderer.onResize(init);
    }


}
